@if (loading) {
    <div class="w-full h-[400px] animate-pulse bg-dat-grey-200"></div>
}
<!-- <pre>Historical Spot: {{spotRatesHistorical() | json}}</pre>
<pre>Historical Contract: {{contractRatesHistorical() | json}}</pre>
<pre>Forecast Spot{{spotRates13MForecast() | json}}</pre>
<pre>Forecast Contract{{contractRates13MForecast() | json}}</pre>
<pre>35d Forecast Contract{{contractRates35DForecast() | json}}</pre>
<pre>35d Forecast Spot{{spotRates35DForecast() | json}}</pre>
<pre>Rate Type: {{this.rateTypePayload() | json }}</pre>
<pre>Trip Type: {{this.tripTypePayload() | json }}</pre> -->


<div [id]="rootId()" #graph class="border border-solid border-dat-grey-100 rounded w-full h-[400px]" [ngClass]="{'!h-0': loading}"></div>
